import Images from "../asset/images"


// get image gift box  from category with item 
export const getGifts = (item)=>{
    

    if(item.id === 408 ||  item.id === 407 ){
        return Images.carImage
        
    }else{
        const category = item.category
        
        switch(category){
            case "necklaces":
                return Images.earringsImage;
            case "rings":
                return Images.ringsImage;
            case "bracelets":
                return Images.bracelets4laImage;
            case "earrings":
                return Images.earringsImage
        }
    }
}